import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiErrorService {
  constructor(private translocoService: TranslocoService) { }

  async getErrorHeader(): Promise<string> {
    return await firstValueFrom(this.translocoService.selectTranslate(`shared.toast.oops_something_went_wrong`));
  }

  async getErrorMessage(crid: string, supportMail: string = "support@neox.energy"): Promise<string> {
    return await firstValueFrom(this.translocoService.selectTranslate('shared.toast.unexpected_error_crid', { supportMail, crid }));
  }
}
